import { ScriptForm } from "./ScriptForm";

export default ScriptForm;
